// Footer.js
import { connect } from 'react-redux';

import {
  SEO_STUFFING_ARTICLE_MAX_SECTIONS_COUNT,
  SUPPORTED_LANGUAGES,
  DMCA_ID,
  SWAG_SOCIAL_MEDIA_LINKS,
  SWAG_ABOUT_LINKS,
  SWAG_SUPPORT_LINKS,
  SWAG_WORK_LINKS,
  SWAG_DISCOVER_LINKS,
  PUBLIC_LOGO_URL_PATH,
  RTA_URL,
  FAQS_FOOTER,
  ABOUT_US_FOOTER,
} from '../RemoteConfigKeys.js';

import Footer from '../component/Footer.jsx';
import withRouter from '../component/WithRouter.jsx';

import updateLanguage from '../action/updateLanguage.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { removeLangFromPath } from '../resource/langPath.js';

const mapStateToProps = (state, ownProps) => {
  const isHomePage = removeLangFromPath(ownProps.location?.pathname) === '/';

  return {
    maxArticleCount: getRemoteConfigData(
      state,
      SEO_STUFFING_ARTICLE_MAX_SECTIONS_COUNT
    ),
    publicLogoUrlPath: getRemoteConfigData(state, PUBLIC_LOGO_URL_PATH),
    supportedLanguages: getRemoteConfigData(state, SUPPORTED_LANGUAGES),
    dmcaId: getRemoteConfigData(state, DMCA_ID),
    socialMediaLinks: getRemoteConfigData(state, SWAG_SOCIAL_MEDIA_LINKS),
    aboutLinks: getRemoteConfigData(state, SWAG_ABOUT_LINKS),
    supportLinks: getRemoteConfigData(state, SWAG_SUPPORT_LINKS),
    workLinks: getRemoteConfigData(state, SWAG_WORK_LINKS),
    discoverLinks: getRemoteConfigData(state, SWAG_DISCOVER_LINKS),
    rtaUrl: getRemoteConfigData(state, RTA_URL),
    footerFAQs: isHomePage
      ? getRemoteConfigData(state, FAQS_FOOTER)
      : undefined,
    footerAboutUs: getRemoteConfigData(state, ABOUT_US_FOOTER),
    shouldShowAboutUsSection: isHomePage,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateLanguage: ({ language }) => dispatch(updateLanguage({ language })),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));
